export default "__VITE_ASSET__B5469YVf__"